<template>
  <div>details</div>
</template>
<script>
export default {};
</script>
